import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as Styles from './Styles';
import { FormInput } from '../../../components/inputs/FormInput';
import { Button } from '../../../components/buttons/Button';
import * as LoginManager from '../../../reducers/ui/login';
import * as AppDataManager from '../../../reducers/data/app';

type Props = {};

export const Form = (_props: Props) => {
	const data = useSelector(LoginManager.Selectors.getData);
	const errors = useSelector(LoginManager.Selectors.getValidators);
	const saveTimeout = useSelector(LoginManager.Selectors.getSaveTimeout);

	const currentYear = useMemo(() => new Date().getFullYear(), []);

	return (
		<>
			<Styles.LogoImage
				src="/images/logo_inter_broker.png"
				alt="logo inter broker"
			/>
			<Styles.ActionFont>zaloguj się</Styles.ActionFont>
			<Styles.ActionBottomFont>
				do Portalu Inter-Broker
			</Styles.ActionBottomFont>
			<FormInput
				onChange={(value) => LoginManager.setField(value, 'login')}
				placeholder="adres e-mail"
				value={data.login}
				error={errors.login}
				errorMessage="podany adres e-mail nie jest poprawny"
			/>
			<FormInput
				onChange={(value) => LoginManager.setField(value, 'password')}
				placeholder="hasło"
				value={data.password}
				error={errors.password}
				type="password"
				errorMessage="podane hasło nie jest poprawne"
			/>
			<Button
				accent="#fff"
				color="#7bb6b3"
				label={
					saveTimeout ? `ZALOGUJ SIĘ (${saveTimeout})` : 'ZALOGUJ SIĘ'
				}
				onClick={async () =>
					!saveTimeout && (await AppDataManager.loginApp())
				}
				variant="solid"
				style={{
					width: '200px',
					height: '50px',
					fontWeight: '600',
					margin: '25px auto',
					cursor: saveTimeout ? 'not-allowed' : 'pointer',
					opacity: saveTimeout ? 0.7 : 1,
				}}
			/>
			<Styles.FooterContainer>
				<Styles.HelpFontContainer>
					<p>Masz problem z logowaniem?</p>
					<p>Zadzwoń: 56 658 42 60</p>
				</Styles.HelpFontContainer>
				<Styles.FooterDivider />
				<Styles.FooterBottomFont>
					<span>© {currentYear} Inter-Broker</span>
				</Styles.FooterBottomFont>
			</Styles.FooterContainer>
		</>
	);
};
